import informationSvg from './information.svg';
import styles from './RefreshReminder.module.css';

export const RefreshReminder = () => {
    return (
        <div className={styles.wrap}>
            <div className={styles.iconContainer}>
                <img src={informationSvg} alt="Information Icon" />
            </div>
            <div className={styles.textContainer}>
                <div className={styles.bodyText}>
                    <b>Don't forget - </b>
                    We'll need to refresh your spending limit after 30 days.
                    That means the amount you have to spend could change based
                    on you and your business.
                </div>
            </div>
        </div>
    );
};
